// The reading list: every article, grouped under its home field (the first
// field it lists). The index shows three starters and links here.

import { LandingLayout, SectionLabel, ArticleList, ArticleCard } from "@/components/templates";
import { BarFooter } from "@/components/layout";
import { ARTICLES } from "@/articles/articles";
import { DOMAINS } from "@/domains/domains";

export function ArticlesPage() {
  const groups = DOMAINS.map((d) => ({ d, items: ARTICLES.filter((a) => a.domains[0] === d.slug) })).filter(
    (g) => g.items.length > 0,
  );
  return (
    <LandingLayout
      label="Articles"
      trail={[{ label: "Articles" }]}
      eyebrow={`${ARTICLES.length} articles`}
      title="Articles that put the instruments to work."
      lede="Each article argues one case and builds its figures from the same modules the tools use. Every number on the page is computed in your browser, and the worked scenario opens in the tool when you want to change it."
      footer={
        <BarFooter className="mt-12">
          <span>Articles · No tracking · Works offline</span>
          <span className="flex flex-wrap items-center gap-4">
            <a href="/about" className="no-underline hover:text-primary">About</a>
            <a href="/privacy" className="no-underline hover:text-primary">Privacy</a>
          </span>
        </BarFooter>
      }
    >
      {groups.map(({ d, items }, i) => (
        <section key={d.slug} aria-labelledby={`field-${d.slug}`}>
          <SectionLabel as="h2" id={`field-${d.slug}`} step={i + 1}>
            {d.name}
          </SectionLabel>
          <ArticleList>
            {items.map((a) => (
              <ArticleCard
                key={a.slug}
                headingLevel={3}
                href={a.href}
                number={a.number}
                kind={a.kind}
                title={a.title}
                dek={a.dek}
                readingTime={a.readingTime}
                topics={a.topics}
                tools={a.tools.map((t) => ({ name: t.name, href: t.href }))}
              />
            ))}
          </ArticleList>
          <p className="mb-0 mt-3 text-sm">
            <a href={`/${d.route}`}>More for {d.name.toLowerCase()} →</a>
          </p>
        </section>
      ))}
    </LandingLayout>
  );
}
